import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import overrideStyles from 'lib/overrideStyle';

import { updateSelectedAnswer } from 'app/modules/knowledge_base/demo';

const SearchedAnswerItem = overrideStyles('div')`
  font-size: 14px;
  padding: 16px;
  & :hover {
    color: #009b00;
    cursor: pointer;
  }
`;

const HighlightedSearchedAnswerItem = overrideStyles('div')`
  font-size: 14px;
  padding: 16px;
  color: #009b00;
  & :hover {
    cursor: pointer;
  }
`;

class SearchResultsItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    SearchResultsItem.propTypes = {
      name: PropTypes.string.isRequired,
      focused: PropTypes.bool.isRequired,
    };
    this.handleMouseDown = this.handleMouseDown.bind(this);
  }

  handleMouseDown() {
    this.props.onMouseDown(this.props.answerId);
  }

  renderKeyFocusedItem() {
    return this.props.focused ? (
      <HighlightedSearchedAnswerItem
        role="button"
        tabIndex="0"
        onMouseDown={this.handleMouseDown}
        onBlur={this.props.onBlur}
      >
        {this.props.name}
      </HighlightedSearchedAnswerItem>
    ) : (
      <SearchedAnswerItem role="button" tabIndex="0" onMouseDown={this.handleMouseDown} onBlur={this.props.onBlur}>
        {this.props.name}
      </SearchedAnswerItem>
    );
  }

  render() {
    return this.renderKeyFocusedItem();
  }
}

export const mapDispatchToProps = dispatch => {
  return {
    onMouseDown: selectedAnswerId => {
      dispatch(
        updateSelectedAnswer({
          selectedResultAnswerId: selectedAnswerId,
        })
      );
    },
  };
};

const SearchResultsItemContainer = connect(
  null,
  mapDispatchToProps
)(SearchResultsItem);

export default SearchResultsItemContainer;
